import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./LoginModal.css";

export default function LoginModal() {
  const { loginModalOpen, closeLoginModal, login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (loginModalOpen) {
      setUsername("");
      setPassword("");
      setError("");
      setLoading(false);
      // let the modal mount before focusing
      setTimeout(() => inputRef.current?.focus(), 30);
    }
  }, [loginModalOpen]);

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") closeLoginModal();
    }
    if (loginModalOpen) window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [loginModalOpen, closeLoginModal]);

  if (!loginModalOpen) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!username.trim() || !password) {
      setError("Enter your username/email and password.");
      return;
    }

    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate("/dashboard");
    } catch (err) {
      const backendMessage =
        err?.response?.data?.message || err?.message || "Invalid username or password.";
      setError(backendMessage);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lmodal__overlay" onMouseDown={(e) => {
      if (e.target === e.currentTarget) closeLoginModal();
    }}>
      <div className="lmodal__card" role="dialog" aria-modal="true" aria-labelledby="lmodal-title">
        <button className="lmodal__close" aria-label="Close" onClick={closeLoginModal}>
          &times;
        </button>

        <p className="lmodal__eyebrow">VP Fitness Admin</p>
        <h2 className="lmodal__title" id="lmodal-title">Sign in</h2>
        <p className="lmodal__sub">Log in to manage users, gallery &amp; SEO content.</p>

        <form className="lmodal__form" onSubmit={handleSubmit} noValidate>
          <label className="lmodal__field">
            <span>Username or email</span>
            <input
              ref={inputRef}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              disabled={loading}
            />
          </label>

          <label className="lmodal__field">
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
          </label>

          {error && (
            <div className="lmodal__error" role="alert">
              {error}
            </div>
          )}

          <button type="submit" className="lmodal__submit" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
